// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Table, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";

import { expiry } from "./expiry";
import { ShowError } from "../../components/error";
import { useRequirements } from "./hooks";
import { ModelEnum } from "./types";
import { EXPIRY_TYPE } from "../requirements/constants";

function RequirementTable({
  // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'expiries' implicitly has an 'any' type.
  expiries,
  // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'handleExpiryChange' implicitly has an 'any' type.
  handleExpiryChange,
  // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'handleSelectionChange' implicitly has an 'any' type.
  handleSelectionChange,
  // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'model' implicitly has an 'any' type.
  model,
  // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'selectedRowKeys' implicitly has an 'any' type.
  selectedRowKeys,
  // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'setNonExpiringRequirements' implicitly has an 'any' type.
  setNonExpiringRequirements,
}) {
  const { loading, error, data } = useRequirements();
  const [searchTerm, setSearchTerm] = useState("");

  const columns = [{ dataIndex: "name", key: "name", title: "Name" }];

  // Filter requirements based on search term for display only
  const filteredRequirements =
    // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'requirement' implicitly has an 'any' type.
    data?.allRequirements?.filter((requirement) =>
      requirement.name.toLowerCase().includes(searchTerm.toLowerCase())
    ) || [];

  // Row selection should preserve all selections, including filtered out items
  const rowSelection = {
    selectedRowKeys,
    onChange: handleSelectionChange,
    preserveSelectedRowKeys: true,
  };

  if (model === ModelEnum.HCP) {
    columns.push({
      key: "expiry",
      /* @ts-expect-error FIXME this wrong type */
      render: expiry({
        expiries,
        handleChange: handleExpiryChange,
        selectedRowKeys,
      }),
      title: "Expires",
    });
  }

  useEffect(() => {
    if (!data?.allRequirements?.length) {
      return;
    }
    // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'requirement' implicitly has an 'any' type.
    const nonExpiringRequirements = data.allRequirements.flatMap((requirement) =>
      requirement?.expiryType === EXPIRY_TYPE.DOES_NOT_EXPIRE ? [requirement._id] : []
    );
    setNonExpiringRequirements(new Set(nonExpiringRequirements));
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <>
      <ShowError message="Unable to fetch the requirements" error={error} />
      <div style={{ marginBottom: 16 }}>
        <Input
          placeholder="Search requirements by name..."
          prefix={<SearchOutlined />}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          allowClear
          style={{ maxWidth: 400 }}
        />
      </div>
      <Table
        columns={columns}
        dataSource={filteredRequirements}
        loading={loading}
        pagination={false}
        rowSelection={rowSelection}
        rowKey="_id"
        size="small"
      />
    </>
  );
}

RequirementTable.propTypes = {
  expiries: PropTypes.object,
  handleExpiryChange: PropTypes.func,
  handleSelectionChange: PropTypes.func,
  model: PropTypes.string.isRequired,
  selectedRowKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export { RequirementTable };
